// extracted by mini-css-extract-plugin
export default {"successIcon":"customPreIcon_successIcon__zyf4V","warningIcon":"customPreIcon_warningIcon__0L7ve","dangerIcon":"customPreIcon_dangerIcon__VrAiy"};